export const OBRAS_KANBAN_LOADING_LABEL = "Carregando obras...";
export const OBRAS_KANBAN_EMPTY_COLUMN_MESSAGE = "Nenhum item";
export const OBRAS_KANBAN_LOAD_MORE_LABEL = "Mostrar mais obras";
